import { LoadUser } from "../../domain/use-case/LoadUser";
import api from "../../services/api";

export class RemoteLoadUser implements LoadUser {
  async handle (params: LoadUser.Params): Promise<any> {
    const response = await api.get(`/user/${params.userId}`)
    return response.data
  }
}